import {
  SaleSchema,
  type SaleData,
  SourceStatusEnum,
  withSaleOrderDetails,
} from '@am3nd-org/pointcraft-types';

export interface EditableSaleOverrides {
  removeFeesOverride: boolean;
  taxEnabledOverride: boolean | null;
  clientPaysFeesOverride: boolean | null;
}

export interface EditableSaleDraft {
  sale: SaleData;
  overrides: EditableSaleOverrides;
}

const EMPTY_PAYMENT_INFO: SaleData['paymentInfo'] = {
  pendingPayments: [],
  completedPayments: [],
  failedPayments: [],
  refundedPayments: [],
  totalAmount: 0,
};

/**
 * Produce the editable, non-financial portion of a sale that is safe to keep
 * locally. V4 payment ownership remains in SaleV4 and the backend aggregate.
 */
export function createEditableSaleSnapshot(sale: SaleData): SaleData {
  return SaleSchema.parse({
    ...withSaleOrderDetails(sale),
    data: [],
    salesMeta: {
      ...sale.salesMeta,
      syncedToQuickBooks: false,
    },
    status: {
      hasBeenCreated: false,
      isCompleted: false,
      isReadyToPay: false,
      currentSaleStatus: SourceStatusEnum.UNPAID,
    },
    financialInfo: {
      ...sale.financialInfo,
      tip: 0,
      balanceDue: sale.financialInfo.total,
    },
    paymentInfo: EMPTY_PAYMENT_INFO,
  });
}

export function hasQuickPayLine(sale: SaleData): boolean {
  return sale.items.some((item) => item.identifier === 'quick-pay-item');
}
